const REDIRECT_FALLBACK_ERROR_CODES = new Set([
  'auth/popup-blocked',
  'auth/operation-not-supported-in-this-environment',
]);

const parseHost = (value?: string | null) => {
  if (!value) {
    return null;
  }

  const trimmed = value.trim().toLowerCase();
  if (!trimmed) {
    return null;
  }

  try {
    return new URL(trimmed).hostname.toLowerCase();
  } catch {
    return trimmed.replace(/\/+$/, '');
  }
};

const isLocalDevelopmentHost = (hostname: string | null) => {
  if (!hostname) {
    return false;
  }

  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '0.0.0.0' ||
    hostname.endsWith('.localhost')
  );
};

export const shouldUseGooglePopupFirst = ({
  authDomain,
  hostname,
}: {
  authDomain?: string | null;
  hostname?: string | null;
} = {}) => {
  const resolvedHostname =
    parseHost(hostname) ??
    (typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : null);
  const resolvedAuthDomain = parseHost(authDomain ?? import.meta.env.VITE_FIREBASE_AUTH_DOMAIN);

  if (isLocalDevelopmentHost(resolvedHostname)) {
    return true;
  }

  if (!resolvedHostname || !resolvedAuthDomain) {
    return false;
  }

  return resolvedHostname !== resolvedAuthDomain;
};

export const shouldFallbackToGoogleRedirect = (error: unknown) => {
  if (
    error &&
    typeof error === 'object' &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    return REDIRECT_FALLBACK_ERROR_CODES.has((error as { code: string }).code);
  }

  return false;
};
